import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m14 7 3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 6v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 14v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 8H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 16h-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 3H9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Wand2";
const Wand2 = memo(themed(Icon));
export {
  Wand2
};
//# sourceMappingURL=wand-2.js.map
